export default "__VITE_ASSET__32aab942__"